import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import logo from '../../images/corper-invest.png';


const Nav = () => {
    const navigate = useNavigate();

    const userType = sessionStorage.getItem('userType');

    // Logout function
    const handleLogout = () => {
        sessionStorage.removeItem('token'); // Clear the token from session storage
        navigate('/login'); // Redirect the user to the login page
    };
    return (
        <>
            <nav className="navbar navbar-expand-sm bg-light shadow-sm fixed-top border-bottom">
                <div className="container-fluid px-4">
                    <Link className="navbar-brand bold" to="/">
                        <span><img src={logo} style={{ width: "80px" }} alt="" /></span>
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                        <ul className="navbar-nav">

                        { userType ==="super admin" ? (

                         <li className="nav-item">
                         <Link to="/admins">
                         <button className="custom-link-inverse">
                             Admins
                         </button>
                         </Link>
                         </li> ) : null}

                            <li className="nav-item">
                                <Link to="/users">
                                    <button className="custom-link-inverse">
                                        Users
                                    </button>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/vacancy">
                                    <button className="custom-link-inverse">
                                        Vacancies
                                    </button>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/learning">
                                    <button className="custom-link-inverse">
                                        Learning
                                    </button>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/notifications">
                                    <button className="custom-link-inverse">
                                        Notifications
                                    </button>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/campaigns">
                                    <button className="custom-link-inverse">
                                        Campaigns
                                    </button>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/mailing-list">
                                    <button className="custom-link-inverse">
                                        Mailing List
                                    </button>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/products">
                                    <button className="custom-link-inverse">
                                        Products
                                    </button>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <button className="btn-custom-sm text-bold" onClick={handleLogout}>
                                    Logout <i className="bi-box-arrow-right"></i>
                                </button>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
            <br /><br /><br />
        </>

    );
};

export default Nav;
